import styled from 'styled-components';

import { grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';

export const RiveFileUploadWrapper = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  position: relative;
  width: ${rem(360)};
  height: ${rem(125)};
`;
